module.exports = __webpack_public_path__ + "static/from-the-mixedup-files-of-mrs-basil-e-frankweiler-02479a8e1553e9037debe356d9227e1f.jpg";